/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GuildItem_guild = {
    readonly slugId: string;
    readonly name: string;
    readonly " $fragmentRefs": FragmentRefs<"GuildMembershipStatus_guild" | "GuildPrimaryPhoto_guild">;
    readonly " $refType": "GuildItem_guild";
};
export type GuildItem_guild$data = GuildItem_guild;
export type GuildItem_guild$key = {
    readonly " $data"?: GuildItem_guild$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"GuildItem_guild">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "displayMembershipStatus"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildItem_guild",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "displayMembershipStatus",
          "variableName": "displayMembershipStatus"
        }
      ],
      "kind": "FragmentSpread",
      "name": "GuildMembershipStatus_guild"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GuildPrimaryPhoto_guild"
    }
  ],
  "type": "Guild",
  "abstractKey": null
};
(node as any).hash = 'b03d049ed95f8217e5ae61739c62ffb6';
export default node;
